/**
 * Cloudflare Turnstile site keys.
 *
 * Site keys are PUBLIC by design — they ship in the HTML of every page that
 * renders a widget, and Cloudflare binds them to an allow-list of hostnames.
 * The matching *secret* is server-side only and never appears in this package
 * or in any client bundle.
 *
 * Widget type: Managed. Invisible for almost every real respondent, escalating
 * to a checkbox only when the signal is bad — which matters here because the
 * highest-risk endpoint is an anonymous stranger POSTing to a published form.
 */
export const TURNSTILE_SITE_KEY = "0x4AAAAAAEKHFBeR7-u2436s";
/**
 * Cloudflare's documented test site keys. Used in dev and test so the widget
 * renders deterministically with no network dependency, paired with the
 * always-passes secret on the server.
 */
export const TURNSTILE_TEST_KEYS = {
    alwaysPasses: "1x00000000000000000000AA",
    alwaysBlocks: "2x00000000000000000000AB",
    forcesChallenge: "3x00000000000000000000FF",
};
/** Header the token is sent in. Must match the server's TURNSTILE_HEADER. */
export const TURNSTILE_HEADER = "cf-turnstile-token";
export const turnstileSiteKey = (isProd) => isProd ? TURNSTILE_SITE_KEY : TURNSTILE_TEST_KEYS.alwaysPasses;
//# sourceMappingURL=turnstile.js.map